'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _reservationCampaign = require('./reservation-campaign');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.reservationCampaign', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('general.reservations', {
        url: '/reservations/{code:string}',
        views: {
            'main@root': {
                component: 'reservationCampaign'
            }
        },
        params: {},
        ncyBreadcrumb: {
            label: '{{$resolve.campaign.campaign.name}}'
        },
        resolve: {
            campaign: ["reservationCampaignService", "$stateParams", function campaign(reservationCampaignService, $stateParams) {
                return reservationCampaignService.getReservationCampaign($stateParams.code);
            }]
        }
    });
}]).component('reservationCampaign', _reservationCampaign.reservationCampaignComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/reservation-campaign/index.js
// module id = 1004
// module chunks = 0